import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/AuthContext';

export default function ProtectedRoute({ children, adminOnly = false, requireActive = false }) {
  const { user, initialLoad } = useAuth();
  const location = useLocation();

  if (initialLoad) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="sans text-xs tracking-[0.3em] uppercase text-neutral-500">Loading…</div>
      </div>
    );
  }
  if (!user) {
    // Preserve where the user was trying to go so Login can bounce them back.
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (adminOnly && user.role !== 'admin') return <Navigate to="/" replace />;
  if (requireActive && user.role !== 'admin' && user.status !== 'active') {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
